<template>
    <div>
        <div class="subtitle font-bold">Thông tin DNVT</div>
        <div class="row pb-2 justify-space-between align-center">
            <div class="xs5">Tên DNVT</div>
            <div class="pl-2 font-bold">
                {{ model.tenDoanhNghiep }}
            </div>
        </div>
    </div>
</template>
<script>
import LenhDienTu from "../../../../class/LenhDienTu";
export default {
    components: {},
    props: {
        model: {
            type: Object,
            default: ()=>new LenhDienTu().get(),
        },
    },
    data() {
        return {};
    },
    methods: {},
    created() {},
    mounted() {},
};
</script>
<style scoped>
</style>
<style lang='scss' scoped>
</style>